/** Candidate-facing account links (shown to every signed-in user). */
export const USER_ACCOUNT_LINKS = [
  { key: 'progress', to: '/dashboard', label: 'Dashboard' },
  { key: 'profile', to: '/edit-profile', label: 'Edit profile' },
  { key: 'history', to: '/quiz-attempts', label: 'Session history' },
];

/** Shown when monetization is live (or admin preview — see Navbar). */
export const USER_BILLING_LINK = { key: 'billing', to: '/billing', label: 'Billing' };

/** Operator console — admin email only. Matches AdminChrome routes. */
export const ADMIN_CONSOLE_LINKS = [
  { key: 'admin-users', to: '/admin', label: 'Users', end: true },
  { key: 'admin-events', to: '/admin/events', label: 'Events' },
  { key: 'admin-ranking', to: '/admin/ranking', label: 'Ranking' },
  { key: 'admin-attempts', to: '/admin/attempts', label: 'All attempts' },
  { key: 'admin-questions', to: '/admin/questions', label: 'Question stats' },
  { key: 'admin-feedback', to: '/admin/feedback', label: 'Feedback' },
  { key: 'admin-emails', to: '/admin/emails', label: 'Emails' },
  { key: 'admin-bank', to: '/edit-questions', label: 'Question bank' },
  { key: 'admin-referrals', to: '/admin/referrals', label: 'Referrals' },
  { key: 'admin-monetization', to: '/admin/plans', label: 'Monetization' },
  { key: 'admin-migration', to: '/admin/migration', label: 'Migration' },
  { key: 'admin-roadmap', to: '/admin/roadmap', label: 'Roadmap' },
];

export function isAdminPath(pathname) {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}
